import { StateCreator } from 'zustand';
import { AuthState, authInitialState, CabinetBootstrapStatus } from './authInitialState';
import { Cabinet, User } from '../../types';
import { NavigateFunction } from 'react-router-dom';

/**
 * @french
 * Interface des actions pour le slice d’authentification.
 */
export interface AuthActions {
  setForgetPasswordEmail: (forgetPasswordEmail: string) => void;
  setForgetPasswordToken: (forgetPasswordToken: string | null) => void;
  setClientCabinetId: (cabinetId: string) => void;
  setUserCabinetId: (cabinetId: string | undefined) => void;
  setCabinetBootstrapStatus: (status: CabinetBootstrapStatus) => void;
  setCabinetBootstrapError: (error: string | undefined) => void;
  retryCabinetBootstrap: () => void;
  setUser: (user: User) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  setIsAdmin: (isAdmin: boolean) => void;
  setUserCabinet: (userCabinet: Cabinet | undefined) => void;
  setLoading: (loading: boolean) => void;
  setRefreshToken: (refreshToken: string) => void;
  setAccessToken: (accessToken: string) => void;
  reset: () => void;
  logout: (navigate: NavigateFunction) => void;
}

/**
 * @french
 * Slice Zustand pour l’authentification : uniquement les actions.
 */
export const createAuthSlice: StateCreator<AuthActions | AuthState> = (set) => ({
  setForgetPasswordEmail: (forgetPasswordEmail) => set({ forgetPasswordEmail }),
  setForgetPasswordToken: (forgetPasswordToken) => set({ forgetPasswordToken }),
  setClientCabinetId: (clientCabinetId) => set({ clientCabinetId }),
  setUserCabinetId: (userCabinetId) => set({ userCabinetId }),
  setCabinetBootstrapStatus: (cabinetBootstrapStatus) => set({ cabinetBootstrapStatus }),
  setCabinetBootstrapError: (cabinetBootstrapError) => set({ cabinetBootstrapError }),
  retryCabinetBootstrap: () =>
    set((state) => ({
      cabinetBootstrapAttempt: (state as AuthState).cabinetBootstrapAttempt + 1,
      cabinetBootstrapStatus: 'idle',
      cabinetBootstrapError: undefined,
      userCabinet: undefined,
    })),
  setUser: (user) => set({ user }),
  setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
  setIsAdmin: (isAdmin) => set({ isAdmin }),
  setUserCabinet: (userCabinet) => set({ userCabinet }),
  setLoading: (loading) => set({ loading }),
  setRefreshToken: (refreshToken) => set({ refreshToken }),
  setAccessToken: (accessToken) => set({ accessToken }),
  reset: () => set(authInitialState),

  /**
   * @french
   * Action globale de déconnexion : réinitialise l’état et redirige vers la page d’authentification.
   */
  logout: (navigate) => {
    // -- Réinitialiser l’état auth
    set(authInitialState);
    // -- Rediriger vers la page de connexion

    navigate('/auth');
  },
});
